import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure, USER_ROLE } from '@ptl/account-management';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { environment } from 'src/environments/environment';
import { ProducerReportCycle, ProducerReportType } from '../interfaces/reports-service.interface';
import { ProducerReportsService } from '../producer-reports.service';
import { MinnesotaPopUpWhyComponent } from './minnesota-pop-up-why/minnesota-pop-up-why.component';

@Component({
    selector: 'app-producer-reports-generate',
    templateUrl: './producer-reports-generate.component.html',
    styleUrls: ['./producer-reports-generate.component.scss'],
    standalone: false
})
export class ProducerReportsGenerateComponent implements OnInit {

  @Input() noEntitlementsMessage: string;

  reportForm: UntypedFormGroup;
  reportSubmitted: boolean = false;
  isLoading: boolean = false;

  reportTypeOptions = [] as ProducerReportType[];
  reportFormatOptions = [] as string[];
  reportCycleOptions = [] as ProducerReportCycle[];

  hasEntitlements = false;

  suppressSubmit = false;


  constructor(
    private fb: UntypedFormBuilder,
    private reportService: ProducerReportsService,
    private entitlementsHelper: EntitlementsHelperService,
    private authoringMode: AuthoringModeService,
    private matDialog: MatDialog,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  async ngOnInit() {
    this.reportForm = this.fb.group({
      reportType: this.fb.control('', [Validators.required]),
      reportFormat: this.fb.control('', [Validators.required]),
      reportCycle: this.fb.control('', [Validators.required])
    });

    this.hasEntitlements = this.authoringMode.getAuthoringMode();

    let selectedAgency = await this.entitlementsHelper.getSelectedAgencyPromise();

    const lob: LINE_OF_BUSINESS_ENUM = await this.entitlementsHelper.getCurrentLobPromise();
    const loginData: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    this.hasEntitlements = await this.entitlementsHelper.entitlementValueForSelectedAgencyByNameAndLob(ENTITLEMENTS.AGENCY_REPORTS, lob, loginData?.userInfo?.role as USER_ROLE);

    if (!this.authoringMode.getAuthoringMode() || this.hasEntitlements) {
      const dropdownResponse = await this.reportService.loadDropdownValues();
      this.reportTypeOptions = dropdownResponse.payload.reportConfigs;
    }

  }

  async submit(formDirectve: FormGroupDirective) {
    this.isLoading = true;

    let response = await this.reportService.createReport(
      this.reportForm.get('reportType').value,
      this.reportForm.get('reportFormat').value,
      this.reportForm.get('reportCycle').value
    ).finally(() => this.isLoading = false);

    this.resetForm(formDirectve);
    this.reportSubmitted = true;
  }

  updateSubLists() {
    let typeVal = this.reportForm.get('reportType').value as ProducerReportType;

    // TODO: Remove this silliness after MN is done with its requirements end of year 2022.
    this.popUpMessage(typeVal);


    if (typeVal) {
      this.reportFormatOptions = typeVal.reportFormats;
      this.reportCycleOptions = typeVal.reportCycles.filter(mappedCycle => {

        let showDateBefore = null;

        switch (environment.initData.brand.ASPID) {
          case "ND":
            showDateBefore = "August 2023";
            break;
          case "WY":
            showDateBefore = "July 2023";
            break;
          case "HM":
            showDateBefore = "July 2023";
            break;
          default:
            break;
        }

        if (!showDateBefore) { return true; }

        return (new Date(mappedCycle.display)) < (new Date(showDateBefore));
      });


      if (this.reportFormatOptions.length === 1) {
        this.reportForm.get('reportFormat').setValue(this.reportFormatOptions[0]);
      }
    } else {
      this.reportFormatOptions = [];
      this.reportCycleOptions = [];
    }
  }

  resetForm(formDirectve: FormGroupDirective) {
    this.reportForm.reset();
    formDirectve.resetForm();
    this.updateSubLists();
  }

  popUpMessage(typeVal) {
    // TODO: Remove this silliness after MN is done with its requirements end of year 2022.
    const showPopUpForRegion = environment.initData.brand.ASPID === 'MN';

    // const showPopUpOnValues = [
    //   'Service Fees Statement',
    //   'Admin Allowance Statement'
    // ]

    if (showPopUpForRegion) {
      // pop up modal

      this.suppressSubmit = true;

      this.matDialog.open(MinnesotaPopUpWhyComponent, {
        maxWidth: '650px',
        maxHeight: '100vh',
        data: {}
      });
    }
  }
}
